import React from 'react';

// CD-5198 placeholder: the planning completion KPI Power BI/Domo report URL is not confirmed yet.
// When it is, replace the inner div with the iframe (see OpsPBIDashboard.js).
export default function PlanningCompletionKpiReport() {
  return (
    <div className='contentwrapperiframe bravo-ds'>
      <div className='report-placeholder'>
        <h4>Planning Completion KPIs</h4>
        <p>The planning completion and ownership KPI report will be available here soon.</p>
      </div>
    </div>
  );
}
